<template>
    <div>
        <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>
        <div class="row mb-2" ref="gameTop">
            <div class="col-lg col-md-12 mx-sm-1 ml-lg-2 mr-lg-1 mb-md-0 mb-lg-2">
                <b-card class="mb-md-2 mb-lg-0">
                    <b-card-title title-tag="h5" title="Game Details"></b-card-title>
                    <b-card-text text-tag="div" class="mb-3">
                        <h6>Title</h6>
                        <h5>{{ game.title || "N/A" }}</h5>
                    </b-card-text>
                    <b-card-text v-if="sites && game && game.location" text-tag="div" class="mb-3">
                        <h6>Location</h6>
                        <h5>{{ game.site.title }}</h5>
                    </b-card-text>
                    <b-card-text v-if="game" text-tag="div" class="mb-3">
                        <h6>Slots</h6>
                        <h5 v-if="game.bookings">{{ (game.slots - freeSpace) }} / {{ game.slots }}</h5>
                    </b-card-text>
                    <b-card-text text-tag="div" class="mb-3">
                        <h6>Date</h6>
                        <h5>{{ gameDate }}</h5>
                    </b-card-text>
                    <b-card-text text-tag="div" class="mb-3">
                        <h6>Start Time</h6>
                        <h5>{{ startTime }}</h5>
                    </b-card-text>
                    <b-card-text text-tag="div" class="mb-3">
                        <h6>End Time</h6>
                        <h5>{{ endtime }}</h5>
                    </b-card-text>
                </b-card>
            </div>
            <div v-if="game.notes && game.notes.length && gameNote.message" class="col-lg col-md-12 mx-sm-1 ml-lg-2 mr-lg-1">
                <b-card class="mb-md-2 mb-lg-0">
                    <b-card-title title-tag="h5" title="Notes"></b-card-title>
                    <b-card-text text-tag="div" class="mb-3">
                        <h5>{{ gameNote.message }}</h5>
                    </b-card-text>
                    <b-card-text><small><template v-if="gameNote.updated_at && gameNote.edit && gameNote.edit.name">Edited {{ gameNote.edit.name }} at {{ formatDate(gameNote.updated_at) }}</template></small></b-card-text>
                </b-card>
            </div>
            <div class="col-lg-4 col-md-12 mx-sm-1 ml-lg-2 mr-lg-1">
                <b-card class="mb-md-2 mb-lg-0">
                    <b-card-title title-tag="h5" title="Controls"></b-card-title>
                    <b-card-text text-tag="div" class="mb-3">
                        <template v-if="game.is_open">
                            <b-button block="block" v-b-modal.addPlayer><i class="fas fa-fw fa-user-plus"></i> Add Player</b-button>
                            <b-button block="block" v-b-modal.addMarshal><i class="fas fa-fw fa-user-shield"></i> Add Marshal</b-button>
                            <hr />
                            <b-button block="block" v-b-modal.gameNote><i class="fal fa-sticky-note"></i> Add/Edit Note</b-button>
                            <hr />
                            <b-button v-if="$can('game-update')" block="block" :href="$routes.route('game.edit', {game: game.id})"><i class="fas fa-fw fa-edit"></i> Edit Game</b-button>
                            <b-button block="block" variant="danger" @click="toggleGame"><i class="far fa-fw fa-flag-checkered"></i> End Game</b-button>
                            <!-- <b-button block="block"><i class="far fa-fw fa-print"></i> Print Paperwork</b-button> -->
                            <b-button v-if="$can('game-delete')" block="block" variant="danger" @click="deleteGameCheck"><i class="far fa-fw fa-trash-alt"></i> Delete Game</b-button>
                        </template>
                        <template v-else>
                            <b-button block="block" variant="success" @click="toggleGame"><i class="fas fa-fw fa-flag-checkered"></i> Re-Open Game</b-button>
                        </template>
                    </b-card-text>
                </b-card>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col mx-2">
                <b-card>
                    <b-card-title class="mb-0" title-tag="h5" title="Marshals"></b-card-title>
                    <b-card-body>
                        <div id="marshal-table" ref="marshalTable"></div>
                    </b-card-body>
                </b-card>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col mx-2">
                <b-card>
                    <b-card-title title-tag="h5" title="Players"></b-card-title>
                    <b-card-body>
                        <div id="player-table" ref="playerTable"></div>
                    </b-card-body>
                </b-card>
            </div>
        </div>

        <b-modal id="addPlayer" title="Add Player" centered no-stacking>
            <b-button block="block" v-b-modal.newPlayer><i class="fas fa-fw fa-user-plus"></i> New Player</b-button>
            <b-button block="block" v-b-modal.addExsisting @click="createMemberTable"><i class="fas fa-fw fa-users"></i> Exsisting Member</b-button>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>

        <b-modal id="newPlayer" title="New Player" size="xl" centered no-stacking>
            <member-create @memberCreated="newMemberBook" @memberCreatedRepeat="newMemberBookRepeat" :repeatable="true" :noEmail="true" :return-member="true"></member-create>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>

        <b-modal id="addExsisting" title="Add Player - Add Exsisting" centered no-stacking size="xl" @show="playerModalShown = true" @hide="resetTables">
            <input class="form-control mb-2" type="search" id="memberSearch" placeholder="Member Search..." v-model="playerSearchQuery" />
            <div id="member-table" ref="memberTable"></div>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>

        <b-modal id="addMarshal" title="Add Marshal" centered no-stacking size="xl" @show="spoofMarshalSearch" @hide="resetTables">
            <!-- <input class="form-control mb-2" type="search" id="memberSearch" placeholder="Marshal Search..." v-model="marshalSearchQuery" /> -->
            <div id="marshal-add-table" ref="marshalAddTable"></div>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>

        <b-modal id="gameNote" title="Game Note" centered size="xl" @show="freezeData" @hide="unfreezeData">
            <b-form>
                <b-form-textarea v-model="gameNote.message" class="mb-2" rows="3" placeholder="Enter a note for this game"></b-form-textarea>
                <b-button @click="saveNote" type="button" variant="primary">Save</b-button>
            </b-form>
            <template #modal-footer="{  }"><div></div></template>
        </b-modal>

        <b-modal id="memberNotes" title="Member Notes" centered size="xl" @ok="noteResolve" @cancel="noteReject">
            <dl>
                <dt>Notes</dt>
                <dd v-for="note in displayNotes">
                    <b-card>
                        <b-card-title><small>{{ note.user.name }}</small></b-card-title>
                        <b-card-text>{{ note.message }}</b-card-text>
                        <template #footer>
                            <small class="text-muted">Logged {{ formatDate(note.created_at) }}</small>
                        </template>
                    </b-card>
                </dd>
            </dl>
        </b-modal>

        <game-player-modal v-if="clickedPlayer" @player-closing="playerClosed" :id="clickedPlayer" :gameRaw="gameRaw" :sites="sites"></game-player-modal>
    </div>
</template>

<script>
import moment from 'moment-timezone';
    export default {
        props: {
            gameRaw: {
                default: false,
            },
            teams: {
                default: false,
            },
        },
        data() {
            return {
                currentCoords: {
                    top: 0,
                    left: 0,
                },
                breadcrumbItems: [],
                game: {
                    plays: [],
                },
                gameDate: null,
                startTime: null,
                endtime: null,
                marshalTable: false,
                marshalAddtable: false,
                playerTable: false,
                memberTable: false,
                clickedPlayer: false,
                freeSpace: 0,
                playerSearch: [],
                playerSearchQuery: null,
                searchTimeout: false,
                currentPage: false,
                addMemberPick: false,
                exsistingPlayerPick: false,
                marshalSearchQuery: null,
                sites: Sites,
                modal: modal,
                playerModalShown: false,
                gameNote: {
                    message: null,
                },
                userList: [],
                modalOpen: false,
                displayNotes: false,
                noteResolve: () => {},
                noteReject: () => {},
            }
        },
        watch: {
            currentPage() {
                this.getMemberData(this.currentPage);
            },
            "game.plays": {
                deep: true,
                handler() {
                    if (this.playerTable) {
                        this.playerTable.replaceData(this.playList);
                    }
                }
            },
            "game.marshals": {
                deep: true,
                handler() {
                    if (this.marshalTable) {
                        this.marshalTable.replaceData(this.game.marshals);
                    }
                }
            },
            playerSearchQuery() {
                if (this.memberTable) {
                    if (this.searchTimeout) {
                        clearTimeout(this.searchTimeout);
                        this.searchTimeout = false;
                    }

                    this.searchTimeout = setTimeout(() => {
                        if (this.playerSearchQuery && this.playerSearchQuery.length) {
                            this.currentPage = "/member?getData=true&full=true&location=" + this.game.site.id + "&search=" + this.playerSearchQuery;
                        } else {
                            this.currentPage = "/member?getData=true&full=true";
                        }

                        clearTimeout(this.searchTimeout);
                        this.searchTimeout = false;
                    }, 750);
                }
            },
            playerSearch: {
                deep: true,
                handler() {
                    if (this.memberTable || this.marshalAddtable) {
                        setTimeout(() => {
                            if (this.memberTable) {
                                this.memberTable.replaceData(this.playerResults);
                            } else if (this.marshalAddTable) {
                                this.marshalAddTable.replaceData(this.playerResults);
                            }
                        });
                    } else {
                        if (this.playerModalShown) {
                            this.createMemberTable();
                        }
                        this.createMarshalAddTable();
                    }
                }
            },
            marshalSearchQuery() {
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                    this.searchTimeout = false;
                }

                this.searchTimeout = setTimeout(() => {
                    // if (this.marshalSearchQuery.length) {
                    //     this.currentPage = "/member?getData=true&full=true&location=" + this.game.site.id + "&search=" + this.marshalSearchQuery;
                    // } else {
                        this.currentPage = this.$routes.route('user.index');
                    // }

                    clearTimeout(this.searchTimeout);
                    this.searchTimeout = false;
                }, 750);
            }
        },
        computed: {
            playersMarshals() {
                var ids = [];

                this.game.bookings.forEach((player) => {
                    if (typeof player.member_id !== 'undefined') {
                        ids.push(player.member_id);
                    }
                })

                // this.game.marshals.forEach((marshal) => {
                //     if (typeof marshal.member_id !== 'undefined') {
                //         ids.push(marshal.member_id);
                //     }
                // })

                return ids;
            },
            playerResults() {
                var players = this.playerSearch.filter((player) => {
                    return !this.playersMarshals.includes(player.id);
                })

                return players.length ? players : [];
            },
            playList() {
                var playList = Object.assign([], this.game.bookings);
                if (this.game.is_open) {
                    let slots = this.game.slots;
                    let playerCount = this.game.bookings.length;
                    this.freeSpace = slots - playerCount;

                    if (this.freeSpace) {
                        var i = 1;
                        while(i <= this.freeSpace) {
                            playList.push({ member: { name: "ZZZZZZZZZZ" }});
                            i++;
                        }
                    }
                }

                return playList;
            },
            marshalOptions() {
                if (this.userList.length) {
                    // Check if the user is already a marshal on the game if so remove them from the list of users to be returned
                    let marshals = this.game.marshals.map((marshal) => {
                        return marshal.user.id;
                    });

                    return this.userList.filter((user) => {
                        return !marshals.includes(user.id);
                    });
                }

                return this.userList;
            },
        },
        methods: {
            freezeData() {
                this.modalOpen = true;
            },
            unfreezeData() {
                this.modalOpen = false;
            },
            resetTables() {
                this.memberTable = false;
                this.playerModalShown = false;
                this.marshalAddTable = false;
                this.marshalSearchQuery = null;
                this.playerSearchQuery = null;
                this.playerSearch = [];
                this.unfreezeData();
            },
            spoofMarshalSearch() {
                axios.get(this.$routes.route('user.index'))
                    .then((result) => {
                        this.userList = result.data;
                        this.createMarshalAddTable();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            populateTimes() {
                this.gameDate = new moment(this.game.start_time).format("DD-MM-YYYY");
                this.startTime = new moment(this.game.start_time).format("HH:mm");
                this.endtime = new moment(this.game.end_time).format("HH:mm");
            },
            generateTables() {
                this.createMarshalTable();
                this.createPlayerTable();
            },
            formatDate(dateString) {
                // Convert the date string into local timezone and format it to DD/MM/YYYY HH:MM
                return new moment(dateString).format('DD/MM/YYYY HH:mm');
            },
            saveNote() {
                if (this.gameNote.id) {
                    axios.put(this.$routes.route('note.update', { note: this.gameNote.id }), this.gameNote)
                        .then((result) => {
                            this.getGameData();
                            this.$bvModal.hide('gameNote');
                            this.$bvToast.toast('Note Saved', {
                                title: 'Note Saved',
                                variant: 'success',
                                solid: true,
                                hideDelay: 2000,
                            });
                            this.getGameData(true);
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                } else {
                    axios.post(this.$routes.route('note.storeForGame', { game: this.game.id }), this.gameNote)
                        .then((result) => {
                            this.getGameData();
                            this.$bvModal.hide('gameNote');
                            this.$bvToast.toast('Note Saved', {
                                title: 'Note Saved',
                                variant: 'success',
                                solid: true,
                                hideDelay: 2000,
                            });
                            this.getGameData(true);
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                }
            },
            createMarshalTable() {
                if (!this.marshalTable) {
                    this.marshalTable = new Tabulator(
                        this.$refs.marshalTable,
                        {
                            placeholder: "No Marshals",
                            data: this.game.marshals,
                            layout: "fitColumns",
                            columns: [
                                {
                                    title: "Name",
                                    field: "user.name",
                                },
                                {
                                    title: "Actions",
                                    field: "id",
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();

                                        let button = document.createElement('button');
                                        button.classList.add('btn', 'btn-sm', 'btn-danger');
                                        button.innerHTML = '<i class="fa fa-trash-alt"></i> Remove';
                                        button.onclick = () => {
                                            this.removeMarshal(data.id);
                                        }

                                        return button;
                                        // return '<button type="button" class="btn btn-sm btn-secondary">Actions</a>';
                                    },
                                },
                            ],
                        }
                    );
                }
            },
            removeMarshal(id) {
                axios.delete(this.$routes.route('marshal.destroy', { marshal: id }))
                    .then((r) => {
                        this.getGameData();
                        // window.location.reload();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            createPlayerTable() {
                if (!this.playerTable) {
                    this.playerTable = new Tabulator(
                        this.$refs.playerTable,
                        {
                            placeholder: "No Players",
                            responsiveLayout: "collapse",
                            data: this.playList,
                            layout: "fitColumns",
                            initialSort: [{ column: "member.name", dir: "asc" }],
                            columns: [
                                {
                                    title: "Name",
                                    field: "member.name",
                                    minWidth: 215,
                                    formatter: (cell) => {
                                        let data = cell.getValue();
                                        let rowData = cell.getRow().getData();
                                        if (data != "ZZZZZZZZZZ") {
                                            if (rowData.member.noShow) {
                                                data = data + ' <i class="far fa-fw fa-calendar-exclamation" title="No Show Limit Restricted"></i>';
                                            }

                                            if (rowData.member.condition_alert) {
                                                data = data + ' <i class="far text-danger fa-fw fa-heartbeat" title="Condition Alert"></i>';
                                            }

                                            return data
                                        } else {
                                            return "Avaliable Slot";
                                        }
                                    },
                                    cellClick: (e, cell) => {
                                        let data = cell.getRow().getData();
                                        if (data.member.name == "ZZZZZZZZZZ") {
                                            this.$bvModal.show('addPlayer');
                                        } else {
                                            // Load the member page in a new tab
                                            window.open(this.$routes.route('member.show', { member: data.member.id }), '_blank');
                                        }
                                    }
                                },
                                {
                                    title: "Member/Player Number",
                                    field: "member.member_number",
                                    minWidth: 232,
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();

                                        return data.member.member_number;
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "Membership Level",
                                    field: "member.member_level.title",
                                    minWidth: 200,
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();
                                        let returnString = cell.getValue();

                                        if (data.member.expired) {
                                            returnString = '<i class="far fa-fw fa-clock"></i> ' + returnString;
                                        }

                                        return returnString;
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "Rental",
                                    field: "deposit",
                                    minWidth: 110,
                                    formatter: (cell) => {
                                        let data = cell.getValue();
                                        let rowData = cell.getRow().getData();

                                        if (rowData.member.name == 'ZZZZZZZZZZ') {
                                            return "";
                                        }

                                        if (rowData.rentals && rowData.rentals.length) {
                                            return '<button type="button" class="btn btn-sm btn-light"><i class="text-success fas fa-fw fa-raygun"></i> Rental Booked</a>';
                                        } else {
                                            return '';
                                        }
                                    },
                                    cellClick: (e, cell) => {
                                        let rowData = cell.getRow().getData();
                                        this.clickedPlayer = rowData.id;
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "Team",
                                    field: "team",
                                    minWidth: 110,
                                    formatter: (cell) => {
                                        let data = cell.getValue();
                                        let rowData = cell.getRow().getData();

                                        if (data) {
                                            // return `<button type="button" class="btn btn-block btn-secondary btn-sm ${data.color}" style="color: ${data.text_color}; background-color: ${data.color}; border-color: ${data.color};"><strong>${data.name}</strong></button>`;
                                            let button = document.createElement('button');
                                            button.classList.add('btn', 'btn-block', 'btn-secondary', 'btn-sm', data.color);
                                            button.style.color = data.text_color;
                                            button.style.backgroundColor = data.color;
                                            button.style.borderColor = data.color;
                                            button.innerHTML = `<strong>${data.name}</strong>`;
                                            button.onclick = () => {
                                                this.clickedPlayer = rowData.id;
                                            }

                                            return button;
                                        }

                                        return "";
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "First Game",
                                    field: "isFirstBooking",
                                    minWidth: 110,
                                    formatter: (cell) => {
                                        let data = cell.getValue();
                                        let rowData = cell.getRow().getData();

                                        if (data) {
                                            return '<button type="button" class="btn btn-sm btn-success"><i class="fas fa-fw fa-check"></i> First Game</a>';
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    title: "Price/Paid (£)",
                                    field: "totalPrice",
                                    minWidth: 130,
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();
                                        if (data.member.name == "ZZZZZZZZZZ") {
                                            return "";
                                        }

                                        let returnString = "£";

                                        returnString += (cell.getValue()) ? (cell.getValue() / 100).toFixed(2) : (0).toFixed(2);

                                        if (data.free_pass) {
                                            returnString = '<i class="fas fa-fw fa-credit-card"></i> ' + returnString;
                                        }

                                        returnString += " / £" + ((data.totalPaid) ? (data.totalPaid / 100).toFixed(2) : (0).toFixed(2));

                                        return returnString;
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "Waiver",
                                    field: "member.waiver",
                                    minWidth: 130,
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();
                                        if (! cell.getValue() && data.member.name != "ZZZZZZZZZZ") {
                                            // return '<button type="button" class="btn btn-sm btn-danger"><i class="fa fa-exclamation-triangle"></i> No Waver</a>';
                                            let button = document.createElement('button');
                                            button.classList.add('btn', 'btn-sm', 'btn-danger');
                                            button.innerHTML = '<i class="fa fa-exclamation-triangle"></i> No Waver';
                                            button.onclick = () => {
                                                this.clickedPlayer = data.id;
                                            }

                                            return button;
                                        } else if (cell.getValue() && data.member.name != "ZZZZZZZZZZ") {
                                            // return '<button type="button" class="btn btn-sm btn-success"><i class="fa fa-check"></i> Valid Waver</a>';
                                            let button = document.createElement('button');
                                            button.classList.add('btn', 'btn-sm', 'btn-success');
                                            button.innerHTML = '<i class="fa fa-check"></i> Valid Waver';
                                            button.onclick = () => {
                                                this.clickedPlayer = data.id;
                                            }

                                            return button;
                                        } else {
                                            return "";
                                        }
                                    },
                                    cellClick: (e, cell) => {
                                        let row = cell.getRow().getData();
                                        this.clickedPlayer = row.id;
                                    }
                                },
                                {
                                    title: "Action",
                                    field: "id",
                                    formatter: (cell) => {
                                        let data = cell.getRow().getData();

                                        if (data.member.name != "ZZZZZZZZZZ") {
                                            // return '<button type="button" class="btn btn-sm btn-secondary">Actions</a>';
                                            let button = document.createElement('button');
                                            button.classList.add('btn', 'btn-sm', 'btn-secondary');
                                            if (data.notes.length) {
                                                button.innerHTML = '<i class="fa fa-fw fa-sticky-note"></i> Actions';
                                                button.onclick = () => {
                                                    this.clickedPlayer = data.id;
                                                }
                                            } else {
                                                button.innerHTML = 'Actions';
                                            }
                                            button.onclick = () => {
                                                this.clickedPlayer = data.id;
                                            }

                                            return button;
                                        } else {
                                            return "";
                                        }
                                    },
                                    cellClick: (e, cell) => {
                                        this.clickedPlayer = cell.getValue();
                                    }
                                },
                            ],
                            rowFormatter: (row) => {
                                let data = row.getData();

                                if (data.state == "arrived") {
                                    let el = row.getElement();
                                    el.classList.add("table-success");
                                } else if (data.state == "no-show") {
                                    let el = row.getElement();
                                    el.classList.add("table-danger");
                                }
                            },
                        }
                    );
                }
            },
            clickPlayer(id) {
                this.clickedPlayer = id;
                this.freezeData();
            },
            createMemberTable() {
                if (!this.memberTable) {
                    if (this.playerModalShown && this.$refs.memberTable) {
                        console.log('Creating Member Table');
                        this.memberTable = new Tabulator(
                            this.$refs.memberTable,
                            {
                                placeholder: "No Members Found",
                                responsiveLayout: "collapse",
                                data: this.playerResults,
                                layout: "fitColumns",
                                initialSort: [{ column: "name", dir: "asc" }],
                                columns: [
                                    {
                                        title: "Name",
                                        field: "name",
                                        minWidth: 215,
                                    },
                                    {
                                        title: "Member Number",
                                        field: "member_number",
                                        minWidth: 232,
                                    },
                                    {
                                        title: "Waiver",
                                        field: "waiver",
                                        minWidth: 130,
                                        formatter: (cell) => {
                                            let data = cell.getRow().getData();
                                            if (! cell.getValue()) {
                                                return '<button type="button" class="btn btn-sm btn-danger"><i class="fa fa-exclamation-triangle"></i> No Waver</a>';
                                            } else {
                                                return "";
                                            }
                                        }
                                    },
                                    {
                                        title: "Status",
                                        field: "id",
                                        formatter: (cell) => {
                                            let data = cell.getRow().getData();

                                            if (data.banned) {
                                                return `<button type="button" class="btn-block btn-danger" disabled>Banned</button>`;
                                            } else if (data.warning) {
                                                return `<button type="button" class="btn-block btn-warning" disabled>Warning</button>`;
                                            } else if (data.blocked) {
                                                return `<button type="button" class="btn-block btn-primary" disabled>Blocked</button>`;
                                            } else {
                                                return `<button type="button" class="btn-block btn-success" disabled>Good</button>`;
                                            }
                                        },
                                    },
                                ],
                                rowClick: (e, row) => {
                                    var data = row.getData();
                                    console.log(data);

                                    this.bookPlayer(data)
                                        .then((r) => {
                                            this.$bvModal.hide('addExsisting')
                                            this.getGameData();
                                            window.location.reload();

                                            this.memberTable = false;
                                        })
                                        .catch((err) => {
                                            console.error(err);
                                        });
                                }
                            }
                        );
                    } else {
                        setTimeout(() => {
                            if (this.playerModalShown) {
                                this.createMemberTable();
                            }
                        }, 100);
                    }
                } else {
                    setTimeout(() => {
                        if (this.playerModalShown) {
                            this.memberTable.replaceData(this.playerResults);
                        }
                    });
                }
            },
            bookPlayer(member) {
                return new Promise((resolve, reject) => {
                    // Check if the member has any notes against them or historic notes on their previous bookings
                    this.displayNotes = [];
                    if (member.notes && member.notes.length) {
                        this.displayNotes.push(member.notes[0]);
                    }

                    if (member.bookings && member.bookings.length) {
                        member.bookings.forEach((booking) => {
                            if (booking.notes && booking.notes.length) {
                                this.displayNotes = this.displayNotes.concat(booking.notes);
                            }
                        });
                    }

                    if (this.displayNotes.length) {
                        this.showNotes(member)
                            .then((r) => {
                                this.processBooking(member)
                                    .then((r) => {
                                        this.noteResolve = () => {};
                                        this.noteReject = () => {};
                                        this.displayNotes = false;
                                        resolve();
                                    })
                                    .catch((err) => {
                                        this.noteResolve = () => {};
                                        this.noteReject = () => {};
                                        this.displayNotes = false;
                                        reject();
                                    });
                            })
                            .catch((err) => {
                                reject();
                            });
                    } else {
                        this.processBooking(member)
                            .then((r) => {
                                this.displayNotes = false;
                                resolve();
                            })
                            .catch((err) => {
                                this.displayNotes = false;
                                reject();
                            });
                    }
                });
            },
            showNotes(member) {
                return new Promise((resolve, reject) => {
                    this.noteResolve = resolve;
                    this.noteReject = reject;
                    this.$bvModal.show('memberNotes');

                });
            },
            processBooking(member) {
                return new Promise((resolve, reject) => {
                    let bookingData = {
                            member_id: member.id,
                            game_id: this.game.id,
                            price: (this.game.marshal_booking_discount ? this.game.marshal_price : this.game.price),
                            state: 'booked',
                        };

                        axios.post(this.$routes.route('booking.store'), bookingData)
                            .then((r) => {
                                resolve();
                            })
                            .catch((err) => {
                                console.error(err);
                                reject();
                            });
                });
            },
            newMemberBook(member) {
                let bookingData = {
                    member_id: member.id,
                    game_id: this.game.id,
                    price: (this.game.marshal_booking_discount ? this.game.marshal_price : this.game.price),
                    state: 'booked',
                };

                axios.post(this.$routes.route('booking.store'), bookingData)
                    .then((r) => {
                        this.$bvModal.hide('newPlayer')
                        setTimeout(() => {
                            this.getGameData();
                            // window.location.reload();
                        }, 100);
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            newMemberBookRepeat(member) {
                let bookingData = {
                    member_id: member.id,
                    game_id: this.game.id,
                    price: (this.game.marshal_booking_discount ? this.game.marshal_price : this.game.price),
                    state: 'booked',
                };

                axios.post(this.$routes.route('booking.store'), bookingData)
                    .then((r) => {
                        this.$bvModal.hide('newPlayer')
                        setTimeout(() => {
                            this.getGameData();
                            this.$bvModal.show('newPlayer');
                            // window.location.reload();
                        }, 100);
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            createMarshalAddTable() {
                if (!this.marshalAddTable) {
                    if (this.$refs.marshalAddTable) {
                        this.marshalAddTable = new Tabulator(
                            this.$refs.marshalAddTable,
                            {
                                placeholder: "No Marshals Found",
                                responsiveLayout: "collapse",
                                data: this.marshalOptions,
                                layout: "fitColumns",
                                initialSort: [{ column: "name", dir: "asc" }],
                                columns: [
                                    {
                                        title: "Name",
                                        field: "name",
                                        minWidth: 215,
                                    },
                                ],
                                rowClick: (e, row) => {
                                    var data = row.getData();

                                    axios.post(this.$routes.route('marshal.store', { game: this.game.id, user: data.id }))
                                        .then((r) => {
                                            this.$bvModal.hide('addMarshal')
                                            setTimeout(() => {
                                                this.getGameData();
                                                window.location.reload();
                                            }, 100);
                                        })
                                        .catch((err) => {
                                            console.error(err);
                                        });
                                }
                            }
                        );
                    } else {
                        setTimeout(() => {
                            this.createMarshalAddTable();
                        }, 100);
                    }
                } else {
                    setTimeout(() => {
                        this.marshalAddTable.replaceData(this.playerResults);
                    });
                }
            },
            redrawTables() {},
            getMemberData(url) {
                axios.get(url)
                .then((result) => {
                    this.playerSearch = result.data.data;
                })
                .catch(err => {
                    console.error(err);
                });
            },
            getGameData(force = false) {
                if (this.modalOpen && ! force) {
                    return;
                }

                this.currentCoords.top = window.scrollY || document.documentElement.scrollTop;

                axios.get('/game/' + this.game.id + '?getData=true')
                    .then((result) => {
                        this.game = result.data;
                        if (this.game.notes && this.game.notes.length) {
                            this.gameNote = this.game.notes[0];
                        }
                        this.populateTimes();
                        this.breadcrumbItems = [
                            {
                                text: "Game Calendar",
                                href: "/game",
                            },
                            {
                                text: this.game.title ? `${this.game.site.title} - ${this.game.title} - ${this.startTime} - ${this.gameDate}` : `${this.game.site.title} - ${this.startTime} - ${this.gameDate}`,
                                active: true,
                            }
                        ];

                        this.$nextTick(() => {
                            window.scrollTo(0, this.currentCoords.top);
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            playerClosed() {
                this.clickedPlayer = false;
                this.unfreezeData();
                this.getGameData();
            },
            toggleGame() {
                this.modal.confirm(() => {
                    this.game.is_open = !this.game.is_open;
    
                    if (! this.game.is_open) {
                        this.game.bookings.forEach((booking) => {
                            if (booking.state == 'booked') {
                                booking.state = 'no-show';
                            }
                        });
                        axios.get(this.$routes.route('game.close', { game: this.game.id }))
                            .then((result) => {
                                this.getGameData();
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    } else {
                        axios.put(this.$routes.route('game.update', { game: this.game.id }), { is_open: this.game.is_open })
                            .then((result) => {
                                this.getGameData();
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    }
                });
            },
            deleteGameCheck() {
                this.modal.confirm(() => {
                    axios.delete(this.$routes.route('game.destroy', { game: this.game.id }))
                        .then((result) => {
                            window.location.href = this.$routes.route('game.index');
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                }, () => {});
            },
        },
        mounted() {
            this.game = this.gameRaw;
            if (this.game.notes && this.game.notes.length) {
                this.gameNote = this.game.notes[0];
            }
            this.populateTimes();
            this.breadcrumbItems = [
                {
                    text: "Game Calendar",
                    href: "/game",
                },
                {
                    text: this.game.title ? `${this.game.site.title} - ${this.game.title} - ${this.startTime} - ${this.gameDate}` : `${this.game.site.title} - ${this.startTime} - ${this.gameDate}`,
                    active: true,
                }
            ];
            setTimeout(() => {
                this.generateTables();
            }, 100);

            setInterval(() => {
                this.getGameData();
            }, 20 * 1000);
        },
    }
</script>